import { useState } from "react";
import Label from "../Label";
import Input from "./InputField";
import { EyeCloseIcon, EyeIcon } from "../../../icons";

interface PinInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  required?: boolean;
}

export default function PinInput({
  label,
  value,
  onChange,
  maxLength = 4,
  required = true,
}: PinInputProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <Label>
        {label}
        {required && <span className="text-error-500"> *</span>}
      </Label>

      <Input
        type={show ? "text" : "password"}
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="pr-12"
      />

      <button
        type="button"
        onClick={() => setShow(!show)}
        className="absolute right-4 top-[42px] text-gray-500 dark:text-gray-400"
      >
        {show ? (
          <EyeIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
        ) : (
          <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
        )}
      </button>
    </div>
  );
}
